/**
 * API 客户端封装 - 统一 fetch + demo auth token 注入 + ApiResponse 解包
 */

import type { ApiResponse, DemoIdentity } from '@ecom/shared'

const TOKEN_KEY = 'ecom_demo_token'
const IDENTITY_KEY = 'ecom_demo_identity'

/** demo auth token 存取 */
export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}
export function setToken(token: string, identity: DemoIdentity) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(IDENTITY_KEY, JSON.stringify(identity))
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(IDENTITY_KEY)
}
export function getIdentity(): DemoIdentity | null {
  const raw = localStorage.getItem(IDENTITY_KEY)
  return raw ? (JSON.parse(raw) as DemoIdentity) : null
}

/** API 基址（开发走 vite proxy /api → :8787；生产由 VITE_API_URL 指定） */
const BASE = import.meta.env.VITE_API_URL ?? '/api'

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const token = getToken()
  const headers = new Headers(init?.headers)
  headers.set('Content-Type', 'application/json')
  if (token) headers.set('x-demo-identity', token)

  const res = await fetch(`${BASE}${path}`, { ...init, headers })
  const body = (await res.json()) as ApiResponse<T>
  if (!body.ok) {
    throw new Error(body.error ?? `请求失败 (${res.status})`)
  }
  return body.data as T
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  put: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'PUT', body: body ? JSON.stringify(body) : undefined }),
  del: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
}
